export default "__VITE_ASSET__26540227__"